import PropTypes from 'prop-types';

export const CREDIT_CARD = 'CREDIT_CARD';
export const NU_CONTA = 'NU_CONTA';
export const DEBIT = 'DEBIT';
export const MULTI_PRODUCT = 'MULTI_PRODUCT';
export const COMPANY_NU_CONTA = 'COMPANY_NU_CONTA';

export const ProspectTypeTypes = PropTypes.oneOf(['credit_card', 'savings', 'debit', 'company_savings', 'global']);

export const ProspectTypeShape = PropTypes.shape({
  buttonLabel: PropTypes.string.isRequired,
  discoveryFields: PropTypes.shape({
    inviter: PropTypes.oneOf(['register_prospect', 'register_prospect_savings', 'register_prospect_debit', 'register_prospect_c', 'register_prospect_global']).isRequired,
    unsolicited: PropTypes.oneOf(['register_prospect', 'register_prospect_savings_web', 'register_prospect_debit', 'register_prospect_c', 'register_prospect_global_web']).isRequired,
  }),
  formTitle: PropTypes.string.isRequired,
  type: ProspectTypeTypes.isRequired,
});

function createProspectType(buttonLabel, formTitle, type, unsolicitedField, inviterField) {
  return {
    buttonLabel,
    formTitle,
    type,
    discoveryFields: {
      inviter: inviterField || unsolicitedField,
      unsolicited: unsolicitedField,
    },
  };
}

const prospectTypes = {
  [CREDIT_CARD]: createProspectType(
    'COMMON.WIDGET.CREDIT_CARD.BUTTON',
    'COMMON.WIDGET.CREDIT_CARD.TITLE',
    'credit_card',
    'register_prospect',
  ),
  [NU_CONTA]: createProspectType(
    'COMMON.WIDGET.NU_CONTA.BUTTON',
    'COMMON.WIDGET.NU_CONTA.TITLE',
    'savings',
    'register_prospect_savings_web',
    'register_prospect_savings',
  ),
  [DEBIT]: createProspectType(
    'COMMON.WIDGET.DEBIT.BUTTON',
    'COMMON.WIDGET.DEBIT.TITLE',
    'debit',
    'register_prospect_debit',
  ),
  [MULTI_PRODUCT]: createProspectType(
    'COMMON.WIDGET.MULTI_PRODUCT.BUTTON',
    'COMMON.WIDGET.MULTI_PRODUCT.TITLE',
    'global',
    'register_prospect_global_web',
    'register_prospect_global',
  ),
  [COMPANY_NU_CONTA]: createProspectType(
    'COMMON.WIDGET.COMPANY_NU_CONTA.BUTTON',
    'COMMON.WIDGET.COMPANY_NU_CONTA.TITLE',
    'company_savings',
    'register_prospect_c',
  ),
};

export function getProspectType(prospectTypeKey = '') {
  return prospectTypes[prospectTypeKey];
}

export function isCompanyProspectType(prospectType) {
  const { type } = prospectType;

  return type === prospectTypes[COMPANY_NU_CONTA].type;
}

export function accumulateProspectType(currProspectType, newProspectType) {
  const creditCard = prospectTypes[CREDIT_CARD].type;
  const conta = prospectTypes[NU_CONTA].type;
  const multiProduct = prospectTypes[MULTI_PRODUCT].type;

  const isAccumulative = currProspectType !== newProspectType
    && [creditCard, conta].includes(currProspectType)
    && [creditCard, conta, multiProduct].includes(newProspectType);

  return isAccumulative ? multiProduct : currProspectType;
}
